import React from 'react';
import { ClickTooltip } from '../../../../../../base/components/ClickTooltip';
import { cutAgeToFirstLetter } from '../../../../../../base/utils';
import { __t } from '../../../../../../base/utils/t';
import { Speciality } from '../../../api/interfaces';

import './styles.scss';
import { useIsMobile } from '../../../../../../base/hooks';

interface Props {
    specialities: Speciality[];
    isUserDeleted: boolean;
    markNewResponseAsReadHandler: () => void;
}

export const Specialities = ({ specialities, isUserDeleted, markNewResponseAsReadHandler }: Props) => {
    const isMobile = useIsMobile();

    if (isUserDeleted) {
        return null;
    }

    if (!specialities.length) {
        return (
            <div className='responses-table-specialities'>
                {isMobile && <span className='responses-table-specialities__title'>{__t('Досвід')}:&nbsp;</span>}
                <div className='responses-table-specialities__item'>
                    <span className='responses-table-specialities__text'>{__t('Робота без кваліфікації')}</span>
                </div>
            </div>
        );
    }

    const visibleSpecialities = specialities.slice(0, 3);
    const hiddenSpecialities = specialities.slice(3);

    return (
        <div className='responses-table-specialities'>
            {isMobile && <span className='responses-table-specialities__title'>{__t('Досвід')}:&nbsp;</span>}
            {visibleSpecialities.map((speciality, i) => (
                <div className='responses-table-specialities__item' key={speciality.id}>
                    <span className='responses-table-specialities__text' title={speciality.name}>
                        {speciality.name}
                    </span>
                    &nbsp;
                    <span className='responses-table-specialities__experience'>
                        {speciality.experienceYears ? cutAgeToFirstLetter(speciality.experienceYears) : ''}
                    </span>
                    {i !== visibleSpecialities.length - 1 ? <>&nbsp;·&nbsp;</> : ''}
                </div>
            ))}
            {!!hiddenSpecialities.length && (
                <>
                    &nbsp;·&nbsp;
                    <ClickTooltip
                        className='responses-table-specialities__modal'
                        wrapperClassName='responses-table-specialities__show-more-link-wrapper'
                        align='left'
                        activeButton={
                            <div
                                onClick={markNewResponseAsReadHandler}
                                className='responses-table-specialities__show-more-link'
                            >{`${__t('Показати ще')} ${hiddenSpecialities.length}`}</div>
                        }
                    >
                        <>
                            {hiddenSpecialities.map((speciality, i) => (
                                <div className='responses-table-specialities__item' key={speciality.id}>
                                    <span className='responses-table-specialities__text' title={speciality.name}>
                                        {speciality.name}
                                    </span>
                                    &nbsp;
                                    <span className='responses-table-specialities__experience'>
                                        {speciality.experienceYears
                                            ? cutAgeToFirstLetter(speciality.experienceYears)
                                            : ''}
                                    </span>
                                    {i !== visibleSpecialities.length - 1 ? <>&nbsp;·&nbsp;</> : ''}
                                </div>
                            ))}
                        </>
                    </ClickTooltip>
                </>
            )}
        </div>
    );
};
